 enum Permissions {
    SHOP_PERMISSIONS = 'CanManageShop',
    CLIENTS_PERMISSIONS = 'CanManageClients',
    ORDERS_PERMISSIONS = 'CanManageOrders',
    ORDERS_PAGE_PERMISSIONS = 'CanSeeOrderPage',
    STORE_PERMISSIONS = 'CanManageStore',
    USERS_PERMISSIONS = 'CanManageUsers',
    ROOMS_PERMISSIONS = 'CanSeeRooms',
}
export {Permissions}